module.exports = __webpack_public_path__ + "img/image13.6f8e39e1.png";